import { createSelector } from 'reselect';
import { isDirty } from 'redux-form';

const changedForm = state => state.CommonState.dirtyTracking.changedForm;
const entireState = state => state;
const changedElement = state => state.CommonState.dirtyTracking.changedElement;

export const getIsDirty = form => {
  return createSelector(
    [changedForm, changedElement, entireState],
    (changedForm, changedElement, entireState) => {
      //redux-forms
      let forms;

      if (form) {
        forms =
          changedForm && changedForm.length > 0
            ? isDirty(form)(entireState)
            : false;
      } else {
        forms =
          changedForm && changedForm.length > 0
            ? changedForm.some(x => isDirty(x)(entireState))
            : false;
      }

      //html-elements
      const elements =
        changedElement && changedElement.length > 0
          ? changedElement.some(x => x.initialValue !== x.newValue)
          : false;

      return forms || elements;
    }
  );
};



// WEBPACK FOOTER //
// ./src/common/Selectors/DirtySelector.js